import {apiUrl} from "../../api/common";
import {EPaymentMethod, Order} from "../../types/order/order";
import axios from "axios";
import dayjs from "dayjs";
import CartEvents from "../../events/CartEvents";
import LaterListEvents from "../../events/LaterListEvents";


export class OrderHandler {

   public static createOrder(shippingAddressId: string,paymentmethod: EPaymentMethod, shippingDate : dayjs.Dayjs, notes: string): Promise<Order> {
         return new Promise<Order>(function (resolve, reject) {
             axios.post(apiUrl + '/orders', shippingDate, {withCredentials: true, params: {
                shippingAddress: shippingAddressId,
                     paymentMethod: paymentmethod,
                     notes: notes
            }}).then((response: any) => {
                 CartEvents.callCartModifiedEvents();
                 LaterListEvents.callLaterListModifiedEvents();
                 resolve(response.data);
             }).catch((err: any) => {
                 reject(err);
             });
         });
   }

   public static getOrders(): Promise<Array<Order>> {
        return new Promise<Array<Order>> (function (resolve, reject) {
            axios.get(apiUrl + '/orders/' ,{withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

}